module.exports = __webpack_public_path__ + "img/208-Marron - Brun Chocolat.jpg";